export default __webpack_public_path__ + "static/media/store_svg1.3a55c05a.svg";